/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  if($(window).width() < 750){
//     $('.logos .grid').slick({
//       dots: true,
//       arrows: false,
//       infinite: true,
//       autoplay: true,
//       autoplaySpeed: 3000,
//       slidesToShow: 1,
//       slidesToScroll: 1
//     });
    $('.image-with-text-column-section .grid').slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
  
  $('.testimonial-slider').slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true
        }
      }
    ]
  });
  
  $('.article-slider').slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
    	  slidesToScroll: 2
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
    	  slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.recipes-slider .grid').slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 750,
        settings: "unslick"
      }
    ]
  });
  if($(window).width() > 749){
    var recipes_height = $(".recipes-slider").height();
    $(".recipes-item").css("height", recipes_height);
  }
  $(".recipes-arrows .recipes-arrow__left").click(function(){
    $('.recipes-slider .grid').slick('slickPrev');
  });
  $(".recipes-arrows .recipes-arrow__right").click(function(){
    $('.recipes-slider .grid').slick('slickNext');
  });
  
  $(".testimonial-wrapper .thumbnail").click(function(){
    $(".testimonial-wrapper .thumbnail").removeClass("active");
    $(this).addClass("active");
    var number = $(this).data("index");
    $('.testimonial-slider').slick('slickGoTo', number);
  });
  
  $(".header__menu .menu__item").hover(function(){
    var menu_item = $(this).data("index");
    $(".header__desktop__upper").toggleClass(menu_item+"--visible");
  });
  
  $(".header__drawer button.sliderow").click(function(){
    var index = $(this).data("index");
    $(".header__wrapper").addClass("menu__item-"+index+"--show");
  });
  $(".header__drawer button.sliderow__back__button").click(function(){
    var index = $(this).data("index");
    $(".header__wrapper").removeClass("menu__item-"+index+"--show");
  });
  
  $(".product-accordion [data-accordion-toggle]").click(function(){
    if ($(this).hasClass("is-open")) {
      $(".product-accordion .accordion-row").removeClass("active");
      $(".product-accordion .accordion-toggle").removeClass("is-open");
      $(this).removeClass("is-open");
      $(this).parent().removeClass("active");
    }else{
      $(".product-accordion .accordion-row").removeClass("active");
      $(".product-accordion .accordion-toggle").removeClass("is-open");
      $(this).addClass("is-open");
      $(this).parent().addClass("active");
    }
  });
  
})();

$(window).resize(function(){
  if($(window).width() > 749){
    var recipes_height = $(".recipes-slider").height();
    $(".recipes-item").css("height", recipes_height);
  }
});

$(document).ready(function() {
  $(".journal-navigation a[href*='#']:not([href='#])").click(function() {
    var h = $(".theme__header").height() + 30;
    let target = $(this).attr("href");
    $('html,body').stop().animate({
      scrollTop: $(target).offset().top - h
    }, 0);
    event.preventDefault();
  });
});


$(window).scroll(function(){
  if($(window).scrollTop() > 0) {
    $(".announcement__wrapper").addClass("announcement__sticky");
  }else{
    $(".announcement__wrapper").removeClass("announcement__sticky");
  }
});


$(document).ready(function() {
  if($('body').hasClass('template-product'))
  {
      var stringToHTML = function (str) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
      };
    
      var meta_specification = document.querySelectorAll(".product-accordion .metafield-multi_line_text_field")[0].innerText;
      document.querySelectorAll(".product-accordion .metafield-multi_line_text_field")[0].innerHTML = stringToHTML(meta_specification)['innerHTML'];
  }
});

/* HC - Updating changes for Product page - 29 Jul '22 */

$(document).ready(function(){
  $(".product-tabs-title").click(function(){
     if($(this).hasClass("hc-active"))
     {
         var newID = $(this).attr("data-id");
         $("#"+newID).slideUp();
         $(this).removeClass("hc-active");
     }
     else
     {
         var newID = $(this).attr("data-id");
         $("#"+newID).slideDown();
         $(this).addClass("hc-active");
         $(".product-tabs-title").not($(this)).removeClass("hc-active");
         $(".product-tabs-content").not($(".product-tabs-content#"+newID)).slideUp();
     }
  });
});

/* HC - New Page Layout - 12 Oct '22 */

$(document).ready(function(){
    $('.hcbtn').click(function(){
        var ids = $(this).attr('href');
        if($(ids).hasClass('hcopen'))
        {}
        else
        {
            $(ids).addClass('hcopen').show();
        }
    });

    $('.hc-close').click(function(){
        $(this).parent().removeClass('hcopen').hide();
    })
});